import Atom from './Atom.js';

// mini store abstraction to make getting and setting
// atom state easier

export default function Store(obj) {
  const store = {};

  const access = () => store;
  
  const add = (key, value) => {
    const atm = new Atom(value);
      
    store[key] = atm;

    Object.defineProperty(access, key, {
      get() {
        return atm.value;
      },
      set(value) {
        atm.setState(value);
      },
    });
  };

  return Object
    .entries(obj)
    .reduce((memo, [key, value]) => {
      add(key, value);
      return memo;
    }, access);
};